module.exports = __webpack_public_path__ + "media/images/emblems/Bulle-coat_of_arms-cf8e1e5809b977a4bef370ecebb04fd0.svg";